export default __webpack_public_path__ + "static/media/brioche.0b04b569.jpg";